<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oeVW8o/images/cover.jpg?1684514528116" alt="This image is the cover for the book Peace in the Valley"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Peace in the Valley
      </h1>
      <p class="bookDescription body article font2">
        <p>John and Anthony always have a hard time carving out some alone time for the holidays. John’s services in search and rescue are in high demand because his dog has a fine nose and a good track record for finding lost souls. What his fellow volunteers don’t realize is Sir Barksalot is actually Anthony—fully transformed—and that man and werewolf are juggling demanding jobs and lost hikers while trying to have their romantic Christmas together.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jana Denardo
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4802e5f6